// extracted by mini-css-extract-plugin
var _1 = "Day-moduleDay__tTwxX";
var _2 = "Day-modulesize16__V6O44";
var _3 = "Day-modulesize20__YAYDO";
var _4 = "Day-modulesize24__y2FG4";
var _5 = "Day-modulesize32__v7Uni";
var _6 = "Day-modulesize40__Ksc5a";
var _7 = "Day-modulesize48__lOXYs";
var _8 = "Day-moduletext__oz_hR Text-moduletext__Z2j5F";
export { _1 as "Day", _2 as "size16", _3 as "size20", _4 as "size24", _5 as "size32", _6 as "size40", _7 as "size48", _8 as "text" }
